exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collaborators-container select{cursor:pointer}.collaborators-container .collaborator-row{margin-top:15px;display:flex;flex-direction:row;justify-content:space-between;align-items:center}.collaborators-container .collaborator-row .icon{color:red;cursor:pointer}", ""]);

// exports
